import axios from "@/plugins/axios";
// import * as example from "./example";

let url = "/api/v1/members/auto-block";

export const autoBlock = {
    delete(data) {
        return axios.delete(url, data).then((result) => result.data);
    },
};
